var _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaymentSignetOwnFunds = function SvgPaymentSignetOwnFunds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 18 18",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F5F5F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#payment-signet-own-funds_svg__a)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.001,
    cy: 8,
    transform: "rotate(-180 8.001 8)",
    fill: "#fff",
    r: 2.667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "payment-signet-own-funds_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 16 -16.0218 0 8 8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#FF6D00",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#FF6D00",
    stopOpacity: 0.05
  })))));
};
export default SvgPaymentSignetOwnFunds;